import Vue from 'vue';
import App from './App.vue';
import './setup/router';
import './setup/fontawesome';
import store from './store';
import locale from './setup/locale';

Vue.prototype.$wz_locale = locale;
import vuetify from './plugins/vuetify';
import './styles/HealthScore/metrics.css';

Vue.config.productionTip = false;

new Vue({
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app');